export enum DirectPaths {
    HOME = "/",
    PLATFORM = "/platform",
    ALTS = "/alts",
    UNLISTED_SHARES = "/alts/unlisted-shares",
    BULLION = "/bullion",
    BULLION_POSTFIX_PATH = "/alts/bullion",
    GOLD = "/gold/24-karat-gold",
    SILVER = "/silver/pure-silver",
    GLOBAL = "/global",
    US_STOCKS = "/us-stocks",
    US_ETFS = "/us-etfs",
    DOCVAULT = "/doc-vault",
    UNIBO = "/unibo",
    CALCULATOR = "/calculators",
    UE_DISCLAIMER = "/unlisted-shares/disclaimer",
    INVESTOR_RELATIONS = "/investor-relations",
    DISCLAIMER = "/disclaimer",
    CONTACT = "/contact",
    PRIVACY_POLICY = "/privacy-policy",
    TERMS_AND_CONDITIONS = "/terms-of-use",
    ANNOUNCEMENT = "/announcement",
    MILESTONE = "/milestone",
    POLICY_CENTER = "/policy-center",
    FD = "/fd",
    FD_POSTFIX_PATH = "/alts/fd",
    BROKING = "/broking",
}

export enum Subdomains {
    HOME = "dev",
}

export enum PathPrefixes {
    HOME = "/home",
}

type SubdomainConfig = {
    prefix: PathPrefixes;
    exceptions: DirectPaths[];
};

type RouteConfiguration = {
    [key in Subdomains]: SubdomainConfig;
};

export const routeConfig: RouteConfiguration = {
    [Subdomains.HOME]: {
        prefix: PathPrefixes.HOME,
        exceptions: [DirectPaths.UNLISTED_SHARES, DirectPaths.DOCVAULT, DirectPaths.UNIBO],
    },
};
